var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6582 12.5V8.75H19.2413V6.25L24.0188 10.625L19.2413 15V12.5H15.6582ZM14.4638 4.625V6.25H0.131348V4.625L7.2976 0L14.4638 4.625ZM6.10322 7.5H8.49197V13.75H6.10322V7.5ZM1.32572 7.5H3.71447V13.75H1.32572V7.5ZM13.2695 7.5V10.625L10.8807 12.875V7.5H13.2695ZM8.61141 15L7.89479 15.625L9.92522 17.5H0.131348V15H8.61141ZM18.047 13.75V17.5H14.4638V20L9.68635 15.625L14.4638 11.25V13.75H18.047Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransfer);
export default __webpack_public_path__ + "static/media/bank_transfer.55ff37899c4e3895d46cdb25b6b30507.svg";
export { ForwardRef as ReactComponent };